export enum NavbarElementsEnum {
    BackButton = 'back-button',
    SidebarButton = 'sidebar-button',
    NavbarLogo = 'navbar-logo',
    None = ''
}
